import { render, staticRenderFns } from "./EnvoyerRecapitulatif.vue?vue&type=template&id=4f409ddc&scoped=true"
import script from "./EnvoyerRecapitulatif.vue?vue&type=script&lang=js"
export * from "./EnvoyerRecapitulatif.vue?vue&type=script&lang=js"
import style0 from "./EnvoyerRecapitulatif.vue?vue&type=style&index=0&id=4f409ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f409ddc",
  null
  
)

export default component.exports